import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsersBetweenLines } from '@fortawesome/pro-solid-svg-icons';
import NavBarHome from '../Layouts/NavBarHome';
import FooterHome from '../Layouts/FooterHome';
import bgImage from '../pagecomponents/screenshots/red.png';

const baseStyles = {
  container: {
    position: 'relative',
    fontFamily: "'Helvetica Neue', Arial, sans-serif",
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
    backgroundImage: `url(${bgImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: '#fff',
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 0,
  },
  content: {
    position: 'relative',
    zIndex: 2,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: '0 20px',
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '10px',
  },
  title: {
    textAlign: 'left',
    fontSize: '80px',
    lineHeight: '0.9',
    margin: 0,
    fontWeight: '700',
    letterSpacing: '-0.02em',
  },
  subtitle: {
    fontSize: '20px',
    margin: '0 0 50px',
    fontWeight: '400',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  claim: {
    fontSize: '48px',
    lineHeight: '1.3',
    margin: '0 0 40px',
    fontWeight: '400',
    maxWidth: '800px',
    whiteSpace: 'pre-wrap',
  },
  button: {
    backgroundColor: '#FF2300',
    border: 'none',
    padding: '14px 28px',
    borderRadius: '12px',
    fontSize: '18px',
    fontWeight: '500',
    cursor: 'pointer',
  },
  footer: {
    position: 'relative',
    zIndex: 2,
  },
};

function NetworkPage() {
  console.log('✅ NetworkPage loaded');

  const [language, setLanguage] = useState(
    () => localStorage.getItem('language') || 'en'
  );

  // Detect viewport
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  // Merge baseStyles with overrides
  const styles = {
    ...baseStyles,
    content: {
      ...baseStyles.content,
      padding: isMobile ? '0 12px' : baseStyles.content.padding,
    },
    title: {
      ...baseStyles.title,
      fontSize: isMobile ? '48px' : baseStyles.title.fontSize,
    },
    subtitle: {
      ...baseStyles.subtitle,
      fontSize: isMobile ? '16px' : baseStyles.subtitle.fontSize,
      margin: isMobile ? '0 0 30px' : baseStyles.subtitle.margin,
    },
    claim: {
      ...baseStyles.claim,
      fontSize: isMobile ? '28px' : baseStyles.claim.fontSize,
      margin: isMobile ? '0 0 30px' : baseStyles.claim.margin,
      maxWidth: isMobile ? '90%' : baseStyles.claim.maxWidth,
    },
    button: {
      ...baseStyles.button,
      padding: isMobile ? '12px 24px' : baseStyles.button.padding,
      fontSize: isMobile ? '16px' : baseStyles.button.fontSize,
    },
    titleWrapper: {
      ...baseStyles.titleWrapper,
      marginBottom: isMobile ? '8px' : baseStyles.titleWrapper.marginBottom,
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.overlay} />
      <NavBarHome language={language} />

      <main style={styles.content}>
        <div style={styles.titleWrapper}>
          <FontAwesomeIcon
            icon={faUsersBetweenLines}
            size={isMobile ? '5x' : '7x'}
            style={{ marginRight: isMobile ? '8px' : '12px' }}
          />
          <h1 style={styles.title}>
            Talent
            <br />
            Collective
          </h1>
        </div>
        <p style={styles.subtitle}>
          A community by{' '}
          <img
            src="/BetherLogowhitecopia.png"
            alt="Bether logo"
            style={{
              height: isMobile ? '0.9em' : '1em',
              verticalAlign: 'middle',
              marginLeft: isMobile ? '6px' : '8px',
            }}
          />
        </p>
        <p style={styles.claim}>
          The go-to community for Talent Development Leaders, by Talent
          Development Leaders
        </p>
        <button style={styles.button}>Coming soon</button>
      </main>

      <div style={styles.footer}>
        <FooterHome language={language} setLanguage={setLanguage} />
      </div>
    </div>
  );
}

export default NetworkPage;
